import type { SearchControlAction } from '@splunk/dashboard-types';

export const shouldResume = ({
    isPaused,
    action,
}: {
    isPaused: boolean;
    action: SearchControlAction;
}) => isPaused && (action === 'resume' || action === 'togglePause');
